import { styled } from "../../../styled-components";

export const ButtonBarViewStyle = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: ${p => p.theme.pageMarginMedium}px;
    margin: ${p => p.theme.componentInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;
`;
